import i18n from "i18next";
import { generatePath } from "react-router-dom";
import UserIcon from "src/icons/user";
import DollarIcon from "src/icons/dollar";
import DiscountIcon from "src/icons/discount";
import { ROUTE } from "src/routing";
import { jsx as _jsx } from "react/jsx-runtime";
const getMenu = () => { return [{ id: "profile", label: i18n.t("label.profile"), link: generatePath(ROUTE.profile), icon: /*#__PURE__*/ _jsx(UserIcon, {}) }, { id: "promotion", label: i18n.t("label.promotions"), link: generatePath(ROUTE.promotion), icon: /*#__PURE__*/ _jsx(DiscountIcon, {}) }, { id: "pay", label: i18n.t("label.pay"), link: generatePath(ROUTE.pay), icon: /*#__PURE__*/ _jsx(DollarIcon, {}) }]; };
export default getMenu;
